module.exports = __webpack_public_path__ + "static/img/guide-14.9c75ded7.png";